import { Center, Spinner } from '@chakra-ui/react';
import EventDetailCategories from 'presentation/components/modules/events/detail/sections/EventDetailCategories';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import { FC } from 'react';
import { useFetchShortEventTypesQuery } from 'rtkQuery/sharespro/queries/events';
import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';

interface Props {
  activeCategoryId?: ID;
}

const EventCategoriesSidebarContainer: FC<Props> = ({ activeCategoryId }) => {
  const { data, isFetching, error, refetch } = useFetchShortEventTypesQuery();
  const { data: profile } = useFetchProfileQuery();

  const wrapByCard = !data;
  let content;
  if (data) {
    content = (
      <EventDetailCategories
        categories={data.items}
        activeCategoryId={activeCategoryId}
        hasAccessToPrivateChannel={profile?.isPrivateChannelAllowed ?? false}
      />
    );
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }
  if (wrapByCard) {
    content = (
      <AppCard p="15px">
        <Center h="100%">{content}</Center>
      </AppCard>
    );
  }

  return content;
};

export default EventCategoriesSidebarContainer;
